(function () {
  const SHELL_OPEN_REQUEST_EVENT = 'menu-navigation-shell:request-open';
  const SHELL_STATE_EVENT = 'menu-navigation-shell:state';
  const shell = document.getElementById('menu-navigation-shell');

  if (!(shell instanceof HTMLElement)) {
    return;
  }

  const shellElement = shell;

  if (document.body && shellElement.parentElement !== document.body) {
    document.body.appendChild(shellElement);
  }

  const overlay = shellElement.querySelector('.menu-navigation-shell__overlay');
  const panel = shellElement.querySelector('.menu-navigation-shell__panel');
  const searchButton = shellElement.querySelector('.menu-navigation-shell__search');
  const closeButton = shellElement.querySelector('.menu-navigation-shell__close');
  const merchandisingPanel = shellElement.querySelector('.menu-navigation-merchandising-panel');
  const merchandisingRoot = shellElement.querySelector('[data-menu-merchandising-root]');
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  const rootView = shellElement.querySelector('[data-menu-view="root"]');
  const l1Nodes = Array.from(shellElement.querySelectorAll('[data-menu-node="l1"]')).filter(function (node) {
    return node instanceof HTMLElement;
  });
  const l2Nodes = Array.from(shellElement.querySelectorAll('[data-menu-node="l2"]')).filter(function (node) {
    return node instanceof HTMLElement;
  });
  const l2ViewAllNodes = Array.from(shellElement.querySelectorAll('[data-menu-node="l2-viewall"]')).filter(function (node) {
    return node instanceof HTMLElement;
  });
  const l2Groups = Array.from(shellElement.querySelectorAll('[data-menu-group="l2"]')).filter(function (group) {
    return group instanceof HTMLElement;
  });
  const l3Groups = Array.from(shellElement.querySelectorAll('[data-menu-group="l3"]')).filter(function (group) {
    return group instanceof HTMLElement;
  });
  const l1DrilldownTriggers = Array.from(shellElement.querySelectorAll('[data-menu-action="open-l2"]')).filter(function (trigger) {
    return trigger instanceof HTMLElement;
  });
  const l2DrilldownTriggers = Array.from(shellElement.querySelectorAll('[data-menu-action="open-l3"]')).filter(function (trigger) {
    return trigger instanceof HTMLElement;
  });
  const merchandisingBlocks = Array.from(shellElement.querySelectorAll('[data-menu-merchandising-block]')).filter(function (block) {
    return block instanceof HTMLElement;
  });

  if (!(rootView instanceof HTMLElement)) {
    return;
  }

  const rootViewElement = rootView;

  /** @type {{ activeL1Index: number | null, activeL2Index: number | null }} */
  const menuState = {
    activeL1Index: null,
    activeL2Index: null,
  };

  /** @type {HTMLElement | null} */
  let activeInvoker = null;
  let isEnhanced = false;

  /**
   * @param {string | number | null | undefined} value
   * @returns {number | null}
   */
  function parseIndex(value) {
    const parsedValue = Number.parseInt(`${value ?? ''}`, 10);
    return Number.isNaN(parsedValue) ? null : parsedValue;
  }

  /**
   * @param {HTMLElement | null | undefined} element
   * @returns {number | null}
   */
  function getElementIndex(element) {
    return parseIndex(element?.dataset.index);
  }

  /**
   * @param {HTMLElement | null | undefined} element
   * @returns {number | null}
   */
  function getElementParentIndex(element) {
    return parseIndex(element?.dataset.parentIndex);
  }

  /**
   * @param {number | null} parentIndex
   * @returns {boolean}
   */
  function hasL2View(parentIndex) {
    return getL2Group(parentIndex) instanceof HTMLElement;
  }

  /**
   * @param {number | null} parentIndex
   * @param {number | null} index
   * @returns {boolean}
   */
  function hasL3View(parentIndex, index) {
    return getL3Group(parentIndex, index) instanceof HTMLElement;
  }

  /**
   * @param {number | null} parentIndex
   * @returns {HTMLElement | null}
   */
  function getL2Group(parentIndex) {
    return (
      l2Groups.find(function (group) {
        return getElementParentIndex(group) === parentIndex;
      }) || null
    );
  }

  /**
   * @param {number | null} parentIndex
   * @param {number | null} index
   * @returns {HTMLElement | null}
   */
  function getL3Group(parentIndex, index) {
    return (
      l3Groups.find(function (group) {
        return getElementParentIndex(group) === parentIndex && getElementIndex(group) === index;
      }) || null
    );
  }

  function emitShellState() {
    document.dispatchEvent(
      new CustomEvent(SHELL_STATE_EVENT, {
        detail: {
          activeL1Index: menuState.activeL1Index,
          open: shellElement.classList.contains('is-open'),
        },
      })
    );
  }

  /**
   * @param {'root' | 'l1' | 'l2'} level
   * @param {{ index?: number | null, parentIndex?: number | null }} [options]
   * @returns {HTMLElement | null}
   */
  function getMerchandisingBlock(level, options = {}) {
    const { index = null, parentIndex = null } = options;

    return (
      merchandisingBlocks.find(function (block) {
        if (block.dataset.menuContextLevel !== level) {
          return false;
        }

        if (level === 'root') {
          return true;
        }

        if (parseIndex(block.dataset.index) !== index) {
          return false;
        }

        if (level === 'l2') {
          return parseIndex(block.dataset.parentIndex) === parentIndex;
        }

        return true;
      }) || null
    );
  }

  /**
   * @param {HTMLElement} element
   * @param {boolean} isActive
   */
  function setMerchandisingVisibility(element, isActive) {
    element.hidden = !isActive;
    element.classList.toggle('is-active', isActive);
    element.setAttribute('aria-hidden', `${!isActive}`);
  }

  function syncMerchandising() {
    if (!(merchandisingRoot instanceof HTMLElement) || merchandisingBlocks.length === 0) {
      return;
    }

    let activeBlock = null;

    if (Number.isInteger(menuState.activeL2Index)) {
      activeBlock = getMerchandisingBlock('l2', {
        index: menuState.activeL2Index,
        parentIndex: menuState.activeL1Index,
      });
    }

    if (!(activeBlock instanceof HTMLElement) && Number.isInteger(menuState.activeL1Index)) {
      activeBlock = getMerchandisingBlock('l1', {
        index: menuState.activeL1Index,
      });
    }

    if (!(activeBlock instanceof HTMLElement)) {
      activeBlock = getMerchandisingBlock('root');
    }

    merchandisingBlocks.forEach(function (block) {
      setMerchandisingVisibility(block, block === activeBlock);
    });

    merchandisingRoot.hidden = !(activeBlock instanceof HTMLElement);
    merchandisingRoot.classList.toggle('has-active-merchandising', activeBlock instanceof HTMLElement);
    merchandisingRoot.setAttribute('aria-hidden', `${!(activeBlock instanceof HTMLElement)}`);
  }

  function resetShopifyDrawerState() {
    if (!(drawerDetails instanceof HTMLDetailsElement)) {
      return;
    }

    drawerDetails.classList.remove('menu-open');
    drawerDetails.removeAttribute('open');

    const summary = drawerDetails.querySelector('summary');

    if (summary instanceof HTMLElement) {
      summary.setAttribute('aria-expanded', 'false');
    }
  }

  /**
   * @param {HTMLElement} element
   * @param {boolean} isActive
   */
  function setElementVisibility(element, isActive) {
    element.classList.toggle('is-active', isActive);

    if (isEnhanced) {
      element.hidden = !isActive;
    } else {
      element.hidden = false;
    }

    element.setAttribute('aria-hidden', `${!isActive}`);
  }

  function syncDrilldownState() {
    l1DrilldownTriggers.forEach(function (trigger) {
      const isExpanded = Number.isInteger(menuState.activeL1Index) && getElementIndex(trigger) === menuState.activeL1Index;

      trigger.setAttribute('aria-expanded', `${isExpanded}`);
      trigger.classList.toggle('is-active', isExpanded);
    });

    l2DrilldownTriggers.forEach(function (trigger) {
      const isExpanded =
        Number.isInteger(menuState.activeL2Index) &&
        getElementParentIndex(trigger) === menuState.activeL1Index &&
        getElementIndex(trigger) === menuState.activeL2Index;

      trigger.setAttribute('aria-expanded', `${isExpanded}`);
      trigger.classList.toggle('is-active', isExpanded);
    });
  }

  function syncShellState() {
    const isDrilldownActive = Number.isInteger(menuState.activeL1Index) || Number.isInteger(menuState.activeL2Index);

    shellElement.classList.toggle('is-drilldown-active', isDrilldownActive);
  }

  function syncViews() {
    setElementVisibility(rootViewElement, true);

    l1Nodes.forEach(function (node) {
      const isActive = !Number.isInteger(menuState.activeL1Index) || getElementIndex(node) === menuState.activeL1Index;
      setElementVisibility(node, isActive);
    });

    l2Groups.forEach(function (group) {
      const isActive = Number.isInteger(menuState.activeL1Index) && getElementParentIndex(group) === menuState.activeL1Index;
      setElementVisibility(group, isActive);
    });

    l2Nodes.forEach(function (node) {
      const isInActiveBranch = getElementParentIndex(node) === menuState.activeL1Index;
      const isActive = !Number.isInteger(menuState.activeL2Index) ? isInActiveBranch : isInActiveBranch && getElementIndex(node) === menuState.activeL2Index;
      setElementVisibility(node, isActive);
    });

    l2ViewAllNodes.forEach(function (node) {
      const isInActiveBranch = getElementParentIndex(node) === menuState.activeL1Index;
      const isActive = isInActiveBranch && !Number.isInteger(menuState.activeL2Index);
      setElementVisibility(node, isActive);
    });

    l3Groups.forEach(function (group) {
      const isActive =
        Number.isInteger(menuState.activeL2Index) &&
        getElementParentIndex(group) === menuState.activeL1Index &&
        getElementIndex(group) === menuState.activeL2Index;

      setElementVisibility(group, isActive);
    });

    syncDrilldownState();
    syncShellState();
    syncMerchandising();
  }

  /**
   * @returns {HTMLElement | null}
   */
  function getActiveView() {
    if (Number.isInteger(menuState.activeL2Index)) {
      return getL3Group(menuState.activeL1Index, menuState.activeL2Index);
    }

    if (Number.isInteger(menuState.activeL1Index)) {
      return getL2Group(menuState.activeL1Index);
    }

    return rootViewElement;
  }

  function focusActiveView() {
    const activeView = getActiveView();

    if (!(activeView instanceof HTMLElement)) {
      return;
    }

    const focusTarget = activeView.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    if (focusTarget instanceof HTMLElement) {
      window.requestAnimationFrame(function () {
        focusTarget.focus();
      });
    }
  }

  function focusShell() {
    const focusTarget =
      closeButton instanceof HTMLElement
        ? closeButton
        : shellElement.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    if (focusTarget instanceof HTMLElement) {
      window.requestAnimationFrame(function () {
        focusTarget.focus();
      });
    }
  }

  /**
   * @param {{ emitState?: boolean, focusView?: boolean }} [options]
   */
  function showRootView(options = {}) {
    const { emitState = true, focusView = false } = options;

    menuState.activeL1Index = null;
    menuState.activeL2Index = null;
    syncViews();

    if (focusView) {
      focusActiveView();
    }

    if (emitState) {
      emitShellState();
    }
  }

  /**
   * @param {number | null} nextIndex
   * @param {{ emitState?: boolean, focusView?: boolean }} [options]
   */
  function showL2View(nextIndex, options = {}) {
    const { emitState = true, focusView = false } = options;

    if (!hasL2View(nextIndex)) {
      return;
    }

    menuState.activeL1Index = nextIndex;
    menuState.activeL2Index = null;
    syncViews();

    if (focusView) {
      focusActiveView();
    }

    if (emitState) {
      emitShellState();
    }
  }

  /**
   * @param {number | null} parentIndex
   * @param {number | null} nextIndex
   * @param {{ emitState?: boolean, focusView?: boolean }} [options]
   */
  function showL3View(parentIndex, nextIndex, options = {}) {
    const { emitState = true, focusView = false } = options;

    if (!hasL3View(parentIndex, nextIndex)) {
      return;
    }

    menuState.activeL1Index = parentIndex;
    menuState.activeL2Index = nextIndex;
    syncViews();

    if (focusView) {
      focusActiveView();
    }

    if (emitState) {
      emitShellState();
    }
  }

  /**
   * @param {number | null} nextIndex
   * @param {HTMLElement | null} trigger
   * @param {{ preferChildView?: boolean }} [options]
   */
  function openShell(nextIndex = null, trigger = null, options = {}) {
    const { preferChildView = false } = options;

    activeInvoker = trigger instanceof HTMLElement ? trigger : activeInvoker;
    resetShopifyDrawerState();

    if (preferChildView && hasL2View(nextIndex)) {
      showL2View(nextIndex, { emitState: false });
    } else {
      showRootView({ emitState: false });
    }

    shellElement.classList.add('is-open');
    shellElement.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-shell-open');
    focusShell();
    emitShellState();
  }

  /**
   * @param {{ returnFocus?: boolean }} [options]
   */
  function closeShell(options = {}) {
    const { returnFocus = true } = options;

    showRootView({ emitState: false });
    shellElement.classList.remove('is-open');
    shellElement.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-shell-open');
    resetShopifyDrawerState();
    emitShellState();

    if (returnFocus && activeInvoker instanceof HTMLElement) {
      activeInvoker.focus();
    }

    activeInvoker = null;
  }

  function showSearchDialog() {
    const searchModal = /** @type {(HTMLElement & { showDialog?: () => void }) | null} */ (
      document.getElementById('search-modal')
    );

    if (typeof searchModal?.showDialog === 'function') {
      searchModal.showDialog();
      return;
    }

    const searchTrigger = document.querySelector('[on\\:click="#search-modal/showDialog"]');

    if (searchTrigger instanceof HTMLElement) {
      searchTrigger.click();
    }
  }

  /**
   * @param {MouseEvent} event
   */
  function handleSearchButtonClick(event) {
    event.preventDefault();
    closeShell({ returnFocus: false });

    window.requestAnimationFrame(function () {
      showSearchDialog();
    });
  }

  document.addEventListener(SHELL_OPEN_REQUEST_EVENT, function (event) {
    if (!(event instanceof CustomEvent)) {
      return;
    }

    const nextIndex = parseIndex(event.detail?.index);
    const trigger = event.detail?.trigger;

    openShell(nextIndex, trigger instanceof HTMLElement ? trigger : null, { preferChildView: true });
  });

  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const trigger = event.target.closest('[data-menu-trigger]');

      if (!trigger) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openShell(null, trigger instanceof HTMLElement ? trigger : null);
    },
    true,
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !shellElement.classList.contains('is-open')) {
      return;
    }

    event.preventDefault();
    closeShell();
  });

  if (closeButton instanceof HTMLButtonElement) {
    closeButton.addEventListener('click', function () {
      closeShell();
    });
  }

  if (searchButton instanceof HTMLButtonElement) {
    searchButton.addEventListener('click', handleSearchButtonClick);
  }

  if (overlay instanceof HTMLElement) {
    overlay.addEventListener('click', function () {
      closeShell();
    });
  }

  shellElement.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    const rootTrigger = event.target.closest('[data-menu-action="open-l2"]');

    if (rootTrigger instanceof HTMLButtonElement && shellElement.contains(rootTrigger)) {
      event.preventDefault();
      const nextIndex = getElementIndex(rootTrigger);

      if (menuState.activeL1Index === nextIndex) {
        showRootView({ focusView: true });
        return;
      }

      showL2View(nextIndex, { focusView: true });
      return;
    }

    const childTrigger = event.target.closest('[data-menu-action="open-l3"]');

    if (childTrigger instanceof HTMLButtonElement && shellElement.contains(childTrigger)) {
      event.preventDefault();
      const parentIndex = getElementParentIndex(childTrigger);
      const nextIndex = getElementIndex(childTrigger);

      if (menuState.activeL1Index === parentIndex && menuState.activeL2Index === nextIndex) {
        showL2View(parentIndex, { focusView: true });
        return;
      }

      showL3View(parentIndex, nextIndex, { focusView: true });
      return;
    }
  });

  if (panel instanceof HTMLElement) {
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Navigation');
  }

  if (merchandisingRoot instanceof HTMLElement && merchandisingPanel instanceof HTMLElement && merchandisingRoot.parentElement !== merchandisingPanel) {
    merchandisingPanel.appendChild(merchandisingRoot);
  }

  isEnhanced = true;
  shellElement.classList.add('is-enhanced');
  shellElement.setAttribute('aria-hidden', 'true');
  syncViews();
})();